










































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import VehicleDetail from '../models/VehicleDetail';
import CarDetail from '@/components/CarDetail.vue';
import BaseServiceMixin from '../mixins/base.service.mixin';
import eventBus from '@/common/bus';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';

@Component({
  name: 'PatternNotFound',
  components: {
    CarDetail,
  },
})
export default class PatternNotFound extends Mixins(BaseServiceMixin) {
  @Prop({ default: () => undefined })
  public vehicleDetail!: VehicleDetail;

  private store = getModule(StoreVuexModule, this.$store);

  private get isVehicleDetailSet() {
    if (Object.keys(this.vehicleDetail).length > 0) {
      return true;
    }
    return false;
  }

  private get showNoProductRedirect(): boolean {
    return this.store.noProductRedirect;
  }

  public mounted() {
    this.trackPatternNotFound();
  }

  private trackPatternNotFound() {
    eventBus.$emit('track', 'MissingPattern', {
      ...this.vehicleDetail,
      regNo: '',
    });
  }

  private gotoHome() {
    this.$emit('back');
  }

  private noProductRedirect() {
    if (this.store.parentOrigin) {
      window.parent.postMessage({ type: 'PRODUCT_NOT_FOUND' }, this.store.parentOrigin);
    }
  }
}
